const regex = /(<([^>]+)>)/gi;

export const removeHTMLTags = (text: string) => {
  return text.replace(regex, "");
};
